import api from '../../utils/api'

export const state = {
  webAppUserBonds: [],
  webAppUserBondMeta: {}
}

export const mutations = {
  SET_WEB_APP_USER_BONDS(state, webAppUserBonds) {
    state.webAppUserBonds = webAppUserBonds
  },
  SET_WEB_APP_USER_BOND_META(state, webAppUserBondMeta) {
    state.webAppUserBondMeta = webAppUserBondMeta
  }
}

export const actions = {
  handleResetMeta: ({ commit }) => commit('SET_WEB_APP_USER_BOND_META', {
    startDate: null,
    endDate: null,
    usernameWeb: '',
    usernameApp: '',
    limit: 10,
  }),

  async handleGetAllPaginated({ commit }, payload) {
    try {
      let params = {}

      if (payload) {
        params = {
          skip: payload.skip || 0,
          limit: payload.limit || 10,
          startDate: payload.startDate || null,
          endDate: payload.endDate || null,
          usernameWeb: payload.usernameWeb || '',
          usernameApp: payload.usernameApp || ''
        }
      }

      const { data: response } = await api.get('/vinculo-web', { params })
      if (response && response.items) {
        commit('SET_WEB_APP_USER_BONDS', response.items)
        commit('SET_WEB_APP_USER_BOND_META', response.meta)
      } else {
        commit('SET_WEB_APP_USER_BONDS', [])
        commit('SET_WEB_APP_USER_BOND_META', {})
      }
    } catch (err) {
    }
  },

  async handleApprove(_, body) {
    try {
      return await api.put(`/vinculo-web/approve/${body._id}`, body)
    } catch (e) {

    }
  },

  async handleDisapprove(_, body) {
    try {
      return await api.put(`/vinculo-web/disapprove/${body._id}`, body)
    } catch (e) {

    }
  },

  async handleDelete(_, _id) {
    try {
      return await api.delete(`/vinculo-web/${_id}`)
    } catch (e) {

    }
  }
}

export const getters = {
  webAppUserBonds: (state) => state.webAppUserBonds,
  webAppUserBondMeta: (state) => state.webAppUserBondMeta
}
